import React from 'react'

import BetSlipBox from '../BetSlipBox'

const RightSidebar = () => {
  return (<BetSlipBox />)
}

export default RightSidebar
